/**
 * US state data, inlined from the Product `us-states` util so this package
 * stays dependency- and alias-free.
 */

export const US_STATE_CODES = [
  "AL",
  "AK",
  "AZ",
  "AR",
  "CA",
  "CO",
  "CT",
  "DE",
  "FL",
  "GA",
  "HI",
  "ID",
  "IL",
  "IN",
  "IA",
  "KS",
  "KY",
  "LA",
  "ME",
  "MD",
  "MA",
  "MI",
  "MN",
  "MS",
  "MO",
  "MT",
  "NE",
  "NV",
  "NH",
  "NJ",
  "NM",
  "NY",
  "NC",
  "ND",
  "OH",
  "OK",
  "OR",
  "PA",
  "RI",
  "SC",
  "SD",
  "TN",
  "TX",
  "UT",
  "VT",
  "VA",
  "WA",
  "WV",
  "WI",
  "WY",
  "DC",
] as const;

export type USStateCode = (typeof US_STATE_CODES)[number];

const US_STATE_SET: ReadonlySet<string> = new Set(US_STATE_CODES);

/** States we actually form companies in. */
export const FORMATION_STATE_CODES = ["DE", "WY"] as const;

export type FormationStateCode = (typeof FORMATION_STATE_CODES)[number];

const FORMATION_STATE_SET: ReadonlySet<string> = new Set(FORMATION_STATE_CODES);

/** True for a 2-letter US state or DC code, case- and whitespace-insensitive. */
export function isValidUSState(code: string): boolean {
  if (typeof code !== "string") return false;
  return US_STATE_SET.has(code.trim().toUpperCase());
}

/** True only for the states new companies may be formed in (DE, WY). */
export function isSupportedFormationState(code: string): boolean {
  if (typeof code !== "string") return false;
  return FORMATION_STATE_SET.has(code.trim().toUpperCase());
}
